import {BufferGeometry,BufferAttribute,Vector3} from 'three';
const rings=16,sides=16,tubes=9,vertices=(rings+1)*(sides+1);
// One draw call contains a broad central neck and four independently torn fibers.
export function createTearBridge(){
 const geometry=new BufferGeometry(),positions=new Float32Array(vertices*tubes*3),indices=[];
 for(let tube=0;tube<tubes;tube++)for(let i=0;i<rings;i++)for(let j=0;j<sides;j++){
  const a=tube*vertices+i*(sides+1)+j,b=a+sides+1;indices.push(a,b,a+1,b,b+1,a+1);
 }
 geometry.setAttribute('position',new BufferAttribute(positions,3));geometry.setIndex(indices);return geometry;
}
const axis=new Vector3(),u=new Vector3(),v=new Vector3(),sample=[0,0,0,0];
export function updateTearBridge(geometry,pair,body,bindings){
 pair.setSurfaceAnchors(bindings.map(b=>body.sample(b)));
 const positions=geometry.attributes.position;
 for(let tube=0;tube<tubes;tube++){
  const strandIndex=Math.floor((tube-1)/2),second=tube>0&&(tube-1)%2===1;
  const strand=pair.strands[strandIndex];
  const active=tube===0?pair.bridge.visible:!second||!strand.intact;
  if(strand&&!strand.intact)axis.fromArray(strand.cutVector).multiplyScalar(second?-1:1);
  else axis.set(...pair.bridge.end).sub(new Vector3().fromArray(pair.bridge.start));
  if(axis.lengthSq()<1e-10)axis.set(1,0,0);else axis.normalize();
  u.set(0,1,0);if(Math.abs(axis.y)>.95)u.set(0,0,1);
  u.cross(axis).normalize();v.crossVectors(axis,u).normalize();
  for(let i=0;i<=rings;i++){
   const t=i/rings;
   if(tube===0)pair.sampleBridge(t,sample);
   else pair.sampleStrand(strandIndex,t,sample,strand.intact?0:second?1:-1);
   for(let j=0;j<=sides;j++){
    const angle=j/sides*Math.PI*2,r=active?sample[3]:0,c=Math.cos(angle)*r,s=Math.sin(angle)*r;
    // Inactive slots collapse to one point so they cast no shadow or triangles.
    positions.setXYZ(tube*vertices+i*(sides+1)+j,active?sample[0]+u.x*c+v.x*s:0,active?sample[1]+u.y*c+v.y*s:0,active?sample[2]+u.z*c+v.z*s:0);
   }
  }
 }
 positions.needsUpdate=true;geometry.computeVertexNormals();geometry.computeBoundingSphere();geometry.computeBoundingBox();
}
